import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import parentTestService from '../../services/ParentTestService';
import LoadProgressBar from './LoadProgressBar';

const LoadProgress = React.memo(({ id, notifyOnTimeout, cacheStatus }) => {
    const mpPropPlayerAllowedResourceLoadTimeMinutes = settingsReader.getPlayerAllowedResourceLoadTimeMinutes();
    if (mpPropPlayerAllowedResourceLoadTimeMinutes) {
        parentTestService.startLoadWaitTimer(id, mpPropPlayerAllowedResourceLoadTimeMinutes, notifyOnTimeout);
    }
    return <LoadProgressBar id={id} caption={t('childTest.loadingInProgress')} cacheStatus={cacheStatus} />;
});

LoadProgress.propTypes = {
    id: PropTypes.number.isRequired,
    notifyOnTimeout: PropTypes.bool,
    cacheStatus: PropTypes.object,
};

export default LoadProgress;
